import Page from 'components/pages/terms'

export default function Terms() {
  const t = useI18n()
  const title = t.seo.title('custom', { value: '使用者條款與隱私權政策' })

  return (
    <>
      <C.Head>
        { h.seo({ title }) }
      </C.Head>
      <Page />
    </>
  )
}
